import { generateApiUrl } from "@/shared/utils";
/* eslint-disable no-console */
/* eslint-disable no-useless-catch */
import httpService from "@/shared/http";
import { pathOr } from "ramda";

export const getHelp = async (key) => {
  try {
    const url = generateApiUrl(["home", "help"], [key]);
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const resId = pathOr(null, ["id"], data);
    const resDescription = pathOr(null, ["description"], data);
    const resPermissions = pathOr([], ["data", "permissions"], response);

    return {
      resId, resDescription, resPermissions
    };
  } catch (error) {
    throw error;
  }
};
export const updateHelp = async (key, id, description) => {
  try {
    const url = generateApiUrl(["home", "help"], [key]);
    const payload = { description };
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
